import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/home/home.vue'
import HomeSearch from '../views/home/homeSearch.vue'
import HomeDetail from '../views/home/homeDetail.vue'
import GeneBank from '../views/geneBank.vue'
import Annotation from '../views/annotation.vue'
import Blast from '../views/blast/blast.vue'
import BlastResult from '../views/blast/blastResult.vue'
import About from '../views/about.vue'
import Personal from '../views/personal.vue'
import Enroll from '../views/enroll/enroll.vue'
import Forgetpasw from '../views/enroll/forgetpasw.vue'
import Changepasw from '../views/enroll/changepasw.vue'
import Register from '../views/enroll/register.vue'
import Examine from '../views/enroll/examine.vue'
import Genus from '../views/backstage/genus/genus.vue'
import Strain from '../views/backstage/strain/strain.vue'
import Species from '../views/backstage/species/species.vue'
import SpeciesSidePage from '../views/backstage/species/SpeciesSidePage.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/home/search',
      name: 'HomeSearch',
      component: HomeSearch
    },
    {
      path: '/home/detail',
      name: 'HomeDetail',
      component: HomeDetail
    },
    {
      path: '/fwalgaepool',
      name: 'GeneBank',
      component: GeneBank
    },
    {
      path: '/annotation',
      name: 'Annotation',
      component: Annotation
    },
    {
      path: '/blast',
      name: 'Blast',
      component: Blast
    },
    {
      path: '/blast/result',
      name: 'BlaseResult',
      component: BlastResult
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/personal',
      name: 'Personal',
      component: Personal
    },
    {
      path: '/login',
      name: 'Enroll',
      component: Enroll
    },
    {
      path: '/login/forgetpasw',
      name: 'Forgetpasw',
      component: Forgetpasw
    },
    {
      path: '/confirm',
      name: 'Changepasw',
      component: Changepasw
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/register/examine',
      name: 'Examine',
      component: Examine
    },
    {
      path: '/genus',
      name: 'Genus',
      component: Genus
    },
    {
      path: '/strain',
      name: 'Strain',
      component: Strain
    },
    {
      path: '/species',
      name: 'Species',
      component: Species
    },
    {
      path: '/species/sidepage',
      name: 'SpeciesSidePage',
      component: SpeciesSidePage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js